module.exports = __webpack_public_path__ + "Flaticon.a25fa9b6e39e73f6e410.svg";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.svg
// module id = ../../../../../src/assets/metronic/src/vendors/flaticon/fonts/Flaticon.svg
// module chunks = styles